
import { Vue, Component } from 'vue-property-decorator';
import qs from 'qs';
import { save } from '../api';
import { isWeiXin } from '@/common/ts/common';
import SlideVerify from '@/components/next/SlideVerify.vue';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import AMapLoader from '@amap/amap-jsapi-loader';
import { Field, Cell, CellGroup, Toast, Calendar, Checkbox, CheckboxGroup, RadioGroup, Radio } from 'vant';
const baseUrl = '20220408CBHXJ';
const AMap: any = null;
Vue.use(Field)
  .use(Cell)
  .use(CellGroup)
  .use(Calendar)
  .use(Checkbox)
  .use(CheckboxGroup)
  .use(Radio)
  .use(RadioGroup);
@Component({
  components: {
    SlideVerify,
    BottomTabbar,
  },
})
export default class Save extends Vue {
  AMap: any = null;
  longitude: string = '';
  latitude: string = '';
  addr: string = '所在位置';
  AMapLoader: any;
  tabs: any[] = [
    {
      title: '报名通道',
      path: `/${baseUrl}/save`,
      id: 1,
    },
    {
      title: '爆款产品',
      path: `/${baseUrl}/rule`,
      id: 2,
    },
    {
      title: '活动信息',
      path: `/${baseUrl}/news`,
      id: 3,
    },
  ];
  activeTab = 0;
  name: string = '';
  phone: string = '';
  village: string = '';
  demand: any = [];
  loan: string  = '1';
  visit: string = '1';
  unionid: string | null = '';
  showSlideVerify = false;
  isWeiXinCheck: any;
  async mounted() {
    this.unionid = window.localStorage.getItem('unionid');
    if (!this.unionid && isWeiXin()) {
      this.WechatLogin();
    } else if (window.udid) {
      this.AppLogin();
    }
    this.loan = '1';
    this.visit = '1';
    this.onLoad();
  }
  onLoad() {
    AMapLoader.load({
      key: '0e409a5781b919c3cf520acb773066c4', // 申请好的Web端开发者Key，首次调用 load 时必填
      version: '1.4.15', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
      plugins: [], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
      AMapUI: {
        // 是否加载 AMapUI，缺省不加载
        version: '1.1', // AMapUI 缺省 1.1
        plugins: [], // 需要加载的 AMapUI ui插件
      },
      Loca: {
        // 是否加载 Loca， 缺省不加载
        version: '1.3.2', // Loca 版本，缺省 1.3.2
      },
    })
      .then((AMap: any) => {
        const map = new AMap.Map('mapadd', { center: [106.575425, 29.553361], zoom: 17 });
        const trafficLayer = new AMap.TileLayer.Traffic({ zIndex: 2 });
        const marker = new AMap.Marker({
                    position: new AMap.LngLat(106.575425, 29.553361),   // 经纬度
                });
        map.add(trafficLayer);
      })
      .catch((e: any) => {
        console.log(e);
      });
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }
  AppDaoHang() {
     window.location.href = 'http://uri.amap.com/marker?position=106.575425,29.553361&name=得意世界&coordinate=gaode&callnative=1';
  }
  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
  fSlideData(res: any) {
      this.showSlideVerify = false;
      if (isWeiXin()) {
      const data = {
            name: this.name,
            phone: this.phone,
            village: this.village,
            demand: this.demand.join(','),
            loan: this.loan,
            visit: this.visit,
            unionid: this.unionid,
            appkey: window.appkey,
            udid: window.udid,
        };
      const lastData = Object.assign(res, data);
      save(lastData).then((result: any) =>
        this.successVote(result),
      );
    } else if (window.udid) {
      const data = {
            name: this.name,
            phone: this.phone,
            village: this.village,
            demand: this.demand.join(','),
            loan: this.loan,
            visit: this.visit,
            unionid: this.unionid,
            appkey: window.appkey,
            udid: window.udid,
        };
      const lastData = Object.assign(res, data);
      save(lastData).then((result: any) =>
        this.successVote(result),
      );
    }
  }
  successVote(res: any) {
    switch (res.code) {
      case 200:
        Toast({
          type: 'success',
          duration: 1200,
          message: res.msg,
        });
        setTimeout(() => {
            location. reload();
        }, 3000);
        break;
      case 201:
        // 需要滑动验证
        this.showSlideVerify = true;
        break;
      case 203:
        if (parseFloat(window.version) >= 4.5) {
          // 需要在App内登录
          window.handleMessage('{"action":"mUserLogin","data":""}');
        } else {
          // 老版本唤起App登录页面栈
          window.location.href = 'client:logout';
        }
        break;
      case 500:
      case 204:
      case 300:
      case 100:
        Toast.fail(res.msg);
        break;
    }
  }
  sub() {
    if (!this.name) {
      Toast('请填写业主姓名！');
      return false;
    } else if (!this.phone) {
      Toast('请填写联系电话！');
      return false;
    } else if (!/^1[345789][0-9]{9}$/.test(this.phone)) {
      Toast('电话号码格式错误！');
      return false;
    } else if (!this.village) {
      Toast('请填写小区名称！');
      return false;
    } else if (!this.demand.join(',')) {
      Toast('请选择整改需求');
      return false;
    } else if (!this.loan) {
      Toast('请选择是否需要建行装修贷');
      return false;
    } else {
        this.submitPerson();
      }
    }
    async submitPerson() {
    if (isWeiXin() && !window.localStorage.getItem('unionid')) {
      this.$dialog
        .confirm({
          title: '微信登录',
          message: '报名前需要进行微信登录',
        })
        .then(() => {
          console.log('确定');
          this.WechatLogin();
        })
        .catch(() => {
          console.log('取消');
        });
      return;
    }
    if (isWeiXin()) {
        this.isWeiXinCheck = 1;
        console.log('开始提交');
        const data = {
            name: this.name,
            phone: this.phone,
            village: this.village,
            demand: this.demand.join(','),
            loan: this.loan,
            visit: this.visit,
            unionid: this.unionid,
            appkey: window.appkey,
            udid: window.udid,
        };
        const saveRes: any = await save(data);
        if (saveRes.code === 200) {
            Toast.success({duration: 3000, message: saveRes.msg});
            setTimeout(() => {
            location. reload();
            }, 3000);
        } else if (saveRes.code === 201) {
            this.showSlideVerify = true;
        } else {
            Toast.fail(saveRes.msg);
        }
    } else {
        this.isWeiXinCheck = 0;
        const data = {
            name: this.name,
            phone: this.phone,
            village: this.village,
            demand: this.demand.join(','),
            loan: this.loan,
            visit: this.visit,
            unionid: this.unionid,
            appkey: window.appkey,
            udid: window.udid,
        };
        const saveRes: any = await save(data);
        if (saveRes.code === 200) {
            Toast.success({duration: 3000, message: saveRes.msg});
            setTimeout(() => {
            location. reload();
            }, 3000);
        } else if (saveRes.code === 201) {
            this.showSlideVerify = true;
        } else if (saveRes.code === 203) {
            if (parseFloat(window.version) >= 4.5) {
                window.handleMessage('{"action":"mUserLogin","data":""}');
            } else {
                window.location.href = 'client:logout';
            }
        } else {
            Toast.fail(saveRes.msg);
        }
    }
  }
}
